import { CHANNEL_TYPES, PROVIDER_TYPES } from '@root/src/vars/general'
import {
    fetchMaxBusinessAuthStatusByConnectorId,
    fetchReworkAuthStatusByConnectorId,
    fetchSmsGateAuthStatusByConnectorId,
} from './fetchReworkAuthStatus'

const REWORK_AUTH_PROVIDER_TYPES = [
    PROVIDER_TYPES.whatsappBasis,
    PROVIDER_TYPES.maxBasis,
    PROVIDER_TYPES.maxDh,
    PROVIDER_TYPES.whatsappApi,
    PROVIDER_TYPES.whatsappDh,
    PROVIDER_TYPES.telegramApi,
    PROVIDER_TYPES.telegramDh,
]

const QR_AUTH_PROVIDER_TYPES = [
    PROVIDER_TYPES.whatsappBasis,
    PROVIDER_TYPES.whatsappApi,
    PROVIDER_TYPES.whatsappDh,
    PROVIDER_TYPES.telegramApi,
    PROVIDER_TYPES.telegramDh,
    PROVIDER_TYPES.maxBasis,
    PROVIDER_TYPES.maxDh,
    PROVIDER_TYPES.maxBusiness,
]

export function getAuthStatusConnectorId(item) {
    return item?.connectorId || item?.id || null
}

export function shouldUseReworkAuthStatus(item) {
    if (!item || item.isActive === false) return false
    return REWORK_AUTH_PROVIDER_TYPES.includes(item.providerType)
}

export function shouldUseMaxBusinessAuthStatus(item) {
    if (!item || item.isActive === false) return false
    const type = item.providerType || item.channelType || item.connectorType
    return type === PROVIDER_TYPES.maxBusiness || type === CHANNEL_TYPES.maxBusiness
}

export function shouldUseSmsGateAuthStatus(item) {
    if (!item || item.isActive === false) return false
    const provider = item.providerType || item.channelType
    return (
        item.connectorType === CHANNEL_TYPES.smsChannel ||
        provider === PROVIDER_TYPES.smsGate ||
        provider === 'sms-gate'
    )
}

export function shouldUseLiveAuthStatus(item) {
    return (
        shouldUseReworkAuthStatus(item) ||
        shouldUseMaxBusinessAuthStatus(item) ||
        shouldUseSmsGateAuthStatus(item)
    )
}

export function shouldShowQrCodeButton(item) {
    if (!item || !item.providerType) return false
    return QR_AUTH_PROVIDER_TYPES.includes(item.providerType)
}

export function isAuthStatusLoading(item, loadingByConnectorId = {}) {
    if (!shouldUseLiveAuthStatus(item)) return false
    const connectorId = getAuthStatusConnectorId(item)
    if (!connectorId) return false
    return Boolean(loadingByConnectorId[connectorId])
}

export function isChannelAuthorized(item, { statusByConnectorId = {}, loadingByConnectorId = {} } = {}) {
    if (!item || item.isActive === false) return false

    if (shouldUseLiveAuthStatus(item)) {
        const connectorId = getAuthStatusConnectorId(item)
        if (!connectorId) return false
        if (loadingByConnectorId[connectorId]) return false

        const liveStatus = statusByConnectorId[connectorId]
        if (liveStatus !== undefined && liveStatus !== null) {
            return liveStatus === true
        }

        return item.alive === true
    }

    return item.alive === true
}

export function fetchReworkAuthStatus(item, options) {
    return fetchReworkAuthStatusByConnectorId(getAuthStatusConnectorId(item), options)
}

export function fetchLiveAuthStatus(item, options) {
    if (shouldUseSmsGateAuthStatus(item)) {
        return fetchSmsGateAuthStatusByConnectorId(getAuthStatusConnectorId(item), options)
    }
    if (shouldUseMaxBusinessAuthStatus(item)) {
        return fetchMaxBusinessAuthStatusByConnectorId(getAuthStatusConnectorId(item), options)
    }
    if (shouldUseReworkAuthStatus(item)) {
        return fetchReworkAuthStatusByConnectorId(getAuthStatusConnectorId(item), options)
    }
}

export function resolveConnectorAuthItem(channel, connectors = []) {
    const connectorId = String(channel?.connectorId || '')
    const connector =
        connectors.find(item => String(item.connectorId || item.id) === connectorId) || {}

    return {
        ...connector,
        connectorId: connector.connectorId || connector.id || channel.connectorId,
        providerType: connector.providerType || channel.providerType,
        isActive: connector.isActive !== false,
    }
}
